export const STATUS_VALUES = ['open', 'soon', 'later', 'closed', 'ended']
